import { useMemo } from 'react';
import useFieldValidation from 'hooks/useFieldValidation';
function getFieldLabel(name, t) {
    switch (name) {
        case 'name':
        case 'fullName':
            return t('specification:supplier_name_capitalize');
        case 'shortName':
            return t('specification:supplier_shortname');
        default:
            return name;
    }
}
function getFieldError(name, form, t) {
    var _a;
    return !((_a = form[name]) === null || _a === void 0 ? void 0 : _a.trim()) ? t('specification:required_field') : null;
}
function useManufacturerValidation(form, t, nameField = 'name') {
    const validatedFields = useMemo(() => [nameField, 'shortName'], [nameField]);
    return useFieldValidation(validatedFields, (field) => getFieldError(field, form, t), (field) => getFieldLabel(field, t));
}
export default useManufacturerValidation;
